import { render, staticRenderFns } from "./AppSplitter.vue?vue&type=template&id=703a3aec&"
import script from "./AppSplitter.vue?vue&type=script&lang=js&"
export * from "./AppSplitter.vue?vue&type=script&lang=js&"
import style0 from "./AppSplitter.vue?vue&type=style&index=0&id=703a3aec&prod&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports